/**
 * Planlayıcı (report-4) satırlarının branding/performans kovası — TEK KAYNAK.
 *
 * Tarihçe: kova eskiden yalnızca `channel_key`'e gömülüydü (`custom_branding_<ts>`)
 * ve anahtar satır oluşturulurken donuyordu. Elle girilen kanallar (Yandex, Bing…)
 * bazı ay performans bazı ay branding olabildiği için bu model yetmiyordu; tek çare
 * aynı kanal için iki paralel satır açıp parayı elle bölmekti.
 *
 * Artık her ay kendi kovasını taşıyabiliyor (`row.buckets[month]`, DB'de
 * `monthly_target_plans.bucket`). Alan boşsa eski anahtar davranışına düşülür,
 * yani mevcut tüm satırlar hiçbir şey yapılmadan aynı şekilde çalışmaya devam eder.
 *
 * report-2 (Branding) ve report-3 (Performans) bu fonksiyonun iki yüzünü kullanır;
 * aynı ay ikisine birden giremez, dolayısıyla çifte sayım imkânsız.
 */
export function plannerBucket(row, month) {
  const b = String(row?.buckets?.[month] ?? row?.buckets?.[String(month)] ?? '')
    .trim()
    .toLowerCase();
  if (b === 'branding' || b === 'performance') return b;

  const k = String(row?.key || '');
  if (k.includes('_performance')) return 'performance';
  if (k.includes('_branding')) return 'branding';
  return null;
}

/** Satırın 1..12 ayları içinde verilen kovadan en az biri var mı? */
export function hasBucketMonth(row, bucket) {
  for (let m = 1; m <= 12; m += 1) {
    if (plannerBucket(row, m) === bucket) return true;
  }
  return false;
}

/** Kovası verilenden FARKLI olan en az bir ay var mı? (report-2'nin eleme kuralı) */
export function hasNonBucketMonth(row, bucket) {
  for (let m = 1; m <= 12; m += 1) {
    if (plannerBucket(row, m) !== bucket) return true;
  }
  return false;
}
